"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = require("react"),
    n = (e = t) && "object" == typeof e && "default" in e ? e.default : e;

function r() {
  return (r = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var a = [],
    l = !1,
    o = function o() {
  if (l) for (var e; e = a.shift();) {
    e();
  }
},
    i = 0,
    c = n.forwardRef(function (e, c) {
  var u = e.onLoad,
      s = e.onReady,
      d = e.scriptUrl,
      f = e.minHeight,
      p = void 0 === f ? 500 : f,
      v = e.style,
      b = void 0 === v ? {} : v,
      m = t.useRef(e.editorId || "editor-" + ++i),
      g = t.useRef(!1),
      y = t.useState(null),
      k = y[0],
      E = y[1],
      C = t.useCallback(function () {
    if (!g.current) {
      g.current = !0;
      var t = e.options || {};
      e.projectId && (t.projectId = e.projectId), e.tools && (t.tools = e.tools), e.appearance && (t.appearance = e.appearance), e.locale && (t.locale = e.locale), E(unlayer.createEditor(r({}, t, {
        id: m.current,
        displayMode: "email",
        source: {
          name: "react-email-editor",
          version: "1.7.8"
        }
      })));
    }
  }, [m.current, e.appearance, e.locale, e.options, e.projectId, e.tools]),
      h = t.useCallback(function (e, t) {
    null == k || k.addEventListener(e, t);
  }, [k]),
      j = t.useCallback(function (e, t) {
    null == k || k.removeEventListener(e, t);
  }, [k]),
      x = t.useCallback(function (e, t) {
    null == k || k.registerCallback(e, t);
  }, [k]),
      I = t.useCallback(function (e) {
    null == k || k.loadDesign(e);
  }, [k]),
      L = t.useCallback(function (e) {
    null == k || k.saveDesign(e);
  }, [k]),
      O = t.useCallback(function (e, t) {
    null == k || k.exportHtml(e, t);
  }, [k]),
      H = t.useCallback(function (e) {
    null == k || k.exportImage(e);
  }, [k]),
      R = t.useCallback(function (e) {
    null == k || k.setMergeTags(e);
  }, [k]),
      D = t.useCallback(function (e) {
    null == k || k.loadBlank(e);
  }, [k]);
  return t.useEffect(function () {
    !function (e, t) {
      if (void 0 === t && (t = "https://editor.unlayer.com/embed.js?2"), function (e) {
        a.push(e);
      }(e), function (e) {
        var t = document.querySelectorAll("script"),
            n = !1;
        return t.forEach(function (t) {
          t.src.includes(e) && (n = !0);
        }), n;
      }(t)) o();else {
        var n = document.createElement("script");
        n.setAttribute("src", t), n.onload = function () {
          l = !0, o();
        }, document.head.appendChild(n);
      }
    }(C, d);
  }, [C, d]), t.useEffect(function () {
    if (k) {
      for (var t = 0, n = Object.entries(e); t < n.length; t++) {
        var r = n[t],
            a = r[0],
            l = r[1];
        /^on/.test(a) && "onLoad" !== a && "onReady" !== a && h(a, l);
      }

      u && u(), s && k.addEventListener("editor:ready", s);
    }
  }, [k, h, u, s, e]), t.useImperativeHandle(c, function () {
    return {
      saveDesign: L,
      exportHtml: O,
      setMergeTags: R,
      editor: k,
      loadDesign: I,
      registerCallback: x,
      addEventListener: h,
      loadBlank: D,
      exportImage: H,
      removeEventListener: j
    };
  }, [L, O, R, k, I, x, h, D, H, j]), n.createElement("div", {
    style: {
      flex: 1,
      display: "flex",
      minHeight: p
    }
  }, n.createElement("div", {
    id: m.current,
    style: r({}, b, {
      flex: 1
    })
  }));
});

exports.EmailEditor = c, exports.default = c;